//Clone from MandateGiveUp for the moment

import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const PaiementOk = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = searchParams.get('SessionId');
    if (!sessionId) return;

    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_URL + `/v1/mandat-confirmation/${sessionId}`);

        if (response.data.status === 'ok') {
          navigate('/connexion');
        }
      } catch (error) {
        console.error('Erreur pendant la récupération des données', error);
      }
    };

    fetchData();
  }, [searchParams, navigate]);

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold">Confirmation en cours...</h2>
    </div>
  );
};

export default PaiementOk;
